import { DataField } from './DataField'
export default function BvnTab({loan}){
    const applicant = loan?.data[0]?.applicant || loan?.data[0]?.reapplicant
    return (
         <div>
            <DataField
                label={"Bank Verification Number (BVN)"}
                value= {applicant?.bvn
                    ? applicant?.bvn
                    : 'Not Provided'}
            />
        </div>
    )
}